// extracted by mini-css-extract-plugin
module.exports = {"root":"CautionSection_root__wpGVx","container":"CautionSection_container__YAXYE","listItem":"CautionSection_listItem__KwJjd","link":"CautionSection_link__LLYkv"};